import styled from 'styled-components';

import { FlexColumn } from 'styles/layouts';

export const Wrapper = styled(FlexColumn)`
  padding: 48px;
  gap: 16px;
`;
